import ActionTypes from "core/actions/actionTypes";
import { IDictionaryEntry } from "core/components/label/ILabel";
import DictionaryUtil from "core/util/dictionary/DictionaryUtil";
import initialState from "../initialState";

type DictionaryData = typeof initialState.dictionary;

export default function dictionaryReducer(state: DictionaryData = initialState.dictionary, action: any) {
	switch(action.type) {

		case ActionTypes.DICTIONARY_LOAD_SUCCESS:

			// old dictionary, keeping temporarily

			return state;

		case ActionTypes.DICTIONARY_ENTRIES_ADD:

			if (action.entries) {
				return DictionaryUtil.addValues(state, action.entries);
			}

			return state;

		case ActionTypes.DICTIONARY_ENTRY_ADD:

			// merge single entry into tree

			if (action.entry) {
				return DictionaryUtil.addValue(state, action.entry);
			}

			return state;

		case ActionTypes.DICTIONARY_ENTRY_REMOVE:

			// remove entry from tree

			if (action.entry) {
				return DictionaryUtil.removeValue(state, action.entry.key, action.entry.language, action.entry.instance);
			}

			return state;

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/core/reducers/dictionary/dictionaryReducer.ts